@if (!offerIssued()) {
  @if (firstLook(); as look) {
    <section class="first-look" aria-labelledby="first-look-title" data-testid="first-look">
      <h2 id="first-look-title" class="first-look__title">First look — provisional</h2>
      <p class="first-look__figure" data-testid="first-look-amount">{{ look.amount | zar }}</p>
      <p class="first-look__basis" data-testid="first-look-basis">
        Worked out from {{ monthsLabel() }} of bank statements{{
          look.financial_statements ? ' and the financial statements' : ''
        }}
        on file, as at {{ look.as_at | date: 'd MMMM y, HH:mm' }}.
      </p>
      <p class="first-look__applied" data-testid="first-look-applied">
        You applied for {{ amountRequested() | zar }}.
      </p>
      <p class="first-look__standing" data-testid="first-look-standing">{{ standingLine }}</p>
    </section>
  } @else {
    <p class="first-look-processing" data-testid="first-look-processing">
      Being processed — CapX will be in contact.
    </p>
  }
}
